
        Component.define('youshare', (el, params) => {
            /**
 * Each component receives the variables explained below
 *
 * @param {HTMLElement} el - Component's main DOM element
 * @param {Object} params - Params to be used
 */


$('.slider-products').slick({
    dots: true,
    autoplay: true,
});

        });